import React from 'react';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { APP_LOGO_URL } from '../../../saas/AppStorageStaticNames';
import { getStringFromLS } from '../../../shared/helper-utils/localStorage';

export default function CabsVoucher() {
  const { appConfig } = useAppContext();
  return (
    <div
      style={{
        maxWidth: '800px',
        margin: '20px auto',
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <img
            src={getStringFromLS(APP_LOGO_URL)}
            alt="Logo"
            style={{ height: '50px', marginRight: '15px' }}
          />
        </div>
        <div style={{ textAlign: 'right' }}>
          <span
            style={{
              display: 'inline-block',
              padding: '5px 12px',
              background: '#28a745',
              color: '#fff',
              borderRadius: '5px',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            Confirmed
          </span>
          <br />
          <small>
            <b>Booking Ref:</b> TS1509U8A98I
          </small>
        </div>
      </div>

      {/* Section: Cab Info */}
      <div style={{ margin: '20px 0' }}>
        <h2 style={{ fontSize: '20px', marginBottom: '5px', color: '#333' }}>
          PRIVATE - Minibus
        </h2>
        <p>
          <b>Pickup Date & Time:</b> 2025-10-20 9:45:00
        </p>
        <p>
          <b>Supplier Ref No:</b> 102-19392889
        </p>
        <p>
          <b>Booking Date:</b> 2025-09-15T12:12:56
        </p>
        <p>
          <b>Transfer Type:</b> Private
        </p>
      </div>

      {/* Section: Pickup & Drop */}
      <div style={{ margin: '20px 0' }}>
        <h3
          style={{
            fontSize: '16px',
            marginBottom: '8px',
            borderBottom: '1px solid #ddd',
            paddingBottom: '5px',
            color: '#444',
          }}
        >
          Pickup & Drop
        </h3>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <div style={{ width: '48%' }}>
            <p style={{ fontWeight: 'bold', color: '#333' }}>Pickup Point</p>
            <p>Hilton Barcelona, Avinguda Diagonal,589-591, BARCELONA</p>
          </div>
          <div style={{ width: '48%' }}>
            <p style={{ fontWeight: 'bold', color: '#333' }}>Drop Point</p>
            <p>Barcelona Sants Train Station</p>
          </div>
        </div>
      </div>

      {/* Section: Guests */}
      <div style={{ margin: '20px 0' }}>
        <h3
          style={{
            fontSize: '16px',
            marginBottom: '8px',
            borderBottom: '1px solid #ddd',
            paddingBottom: '5px',
            color: '#444',
          }}
        >
          Guests
        </h3>
        <p>Mr Vishnu Kanth</p>
      </div>

      {/* Section: Driver Details */}
      <div style={{ margin: '20px 0' }}>
        <h3
          style={{
            fontSize: '16px',
            marginBottom: '8px',
            borderBottom: '1px solid #ddd',
            paddingBottom: '5px',
            color: '#444',
          }}
        >
          Driver Details
        </h3>
        <p>
          <b>Driver Name:</b> Confirmed
        </p>
        <p>
          <b>Driver Contact:</b> Confirmed
        </p>
        <p>
          <b>Vehicle Number:</b> Confirmed
        </p>
      </div>

      {/* Section: Fare Details */}
      <div style={{ margin: '20px 0' }}>
        <h3
          style={{
            fontSize: '16px',
            marginBottom: '8px',
            borderBottom: '1px solid #ddd',
            paddingBottom: '5px',
            color: '#444',
          }}
        >
          Fare Details
        </h3>
        <p>
          <b>Payment Status:</b> Paid
        </p>
        <p
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#E97E13',
          }}
        >
          Total Amount: EUR 73.21
        </p>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '20px', fontSize: '14px', color: '#555' }}>
        <p>
          <b>Fulfilled By:</b> {appConfig?.companyName}
        </p>
      </div>
    </div>
  );
}
